// extracted by mini-css-extract-plugin
module.exports = {"customWrapper":"Blocks_customWrapper__nCslr","blocks":"Blocks_blocks___l5Rp"};